export const getPaddingTop = (element: HTMLElement) => {
  const paddingTop = getComputedStyle(element).paddingTop;
  return paddingTop ? parseFloat(paddingTop) : 0;
};
